export var USER_MESSAGE_EVENT_NAME = 'userChatMessageAdded';
export var AGENT_MESSAGE_EVENT_NAME = 'agentChatMessageAdded';
export var METADATA_CHANGED_EVENT_NAME = 'onMetaDataChanged';
export var TICKET_HISTORY_EVENT = 'ticketHistoryEvent';
export var MESSAGE_STATUS_CHANGED_EVENT_NAME = 'chatMessageStatusChanged';
export var TICKET_AGENT_EMAIL_READ_EVENT_NAME = 'agentReplyEmailRead';
export var TICKET_AGENT_REPLY_ADDED = 'agentReplyAdded';
export var TICKET_PHONE_CALL_ADDED = 'phoneCallAdded';
export var TICKET_CSAT_SUBMITTED = 'csatSubmitted';
export var AI_TICKET_SUMMARY_EVENT = 'aiTicketSummaryEvent';
export var STATUS_CHANGED_EVENT_NAME = 'chatStatusChanged';
export var CHAT_STARTED_EVENT_NAME = 'chatStarted';
export var CHAT_REOPENED_EVENT_NAME = 'chatReopened';
export var USER_UPDATED_EVENT_NAME = 'chatUserUpdated';
export var AGENT_UPDATED_EVENT_NAME = 'agentUpdated';
export var WEB_NOTIFICATION_EVENT_NAME = 'webNotification';
export var AUTO_ASSIGN_EVENT_NAME = 'autoAssign';
export var AUTO_ROUTING_EVENT_NAME = 'autoRouting';
export var TICKET_UPDATED_EVENT = 'ticketUpdated';
export var TICKET_DELETED_EVENT = 'ticketDeleted';
export var PRESENCE_UPDATE_EVENT = 'presenceUpdated';
export var PRESENCE_DELETED_EVENT = 'presenceDeleted';
export var INC_SAVED_VIEW_COUNTER = 'INC_SAVED_VIEW_COUNTER';
export var DEC_SAVED_VIEW_COUNTER = 'DEC_SAVED_VIEW_COUNTER';
export var ALL_LANGUAGES_TICKET_LIST_RT = 'all-langs';
export var ControlRoomDashboardChangeType;
(function (ControlRoomDashboardChangeType) {
    ControlRoomDashboardChangeType[ControlRoomDashboardChangeType["INCREMENT"] = 1] = "INCREMENT";
    ControlRoomDashboardChangeType[ControlRoomDashboardChangeType["DECREMENT"] = -1] = "DECREMENT";
})(ControlRoomDashboardChangeType || (ControlRoomDashboardChangeType = {}));
// enum can be deleted after removing the old events
export var RealTimeEventType;
(function (RealTimeEventType) {
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_TICKET"] = 100] = "SUBSCRIBE_TO_TICKET";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_ACCOUNT"] = 105] = "SUBSCRIBE_TO_ACCOUNT";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_IMPORT"] = 110] = "SUBSCRIBE_TO_IMPORT";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_WEB_NOTIFICATIONS"] = 115] = "SUBSCRIBE_TO_WEB_NOTIFICATIONS";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_AGENT_STATUS"] = 120] = "SUBSCRIBE_TO_AGENT_STATUS";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_AGENT_CHAT"] = 130] = "SUBSCRIBE_TO_AGENT_CHAT";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_TICKET_LIST"] = 140] = "SUBSCRIBE_TO_TICKET_LIST";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_AUTO_ROUTING"] = 150] = "SUBSCRIBE_TO_AUTO_ROUTING";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_SAVED_VIEW_COUNTER"] = 160] = "SUBSCRIBE_TO_SAVED_VIEW_COUNTER";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_AI_TICKET_SUMMARIES"] = 170] = "SUBSCRIBE_TO_AI_TICKET_SUMMARIES";
    RealTimeEventType[RealTimeEventType["TICKET_USER_MESSAGE"] = 300] = "TICKET_USER_MESSAGE";
    RealTimeEventType[RealTimeEventType["TICKET_AGENT_MESSAGE"] = 310] = "TICKET_AGENT_MESSAGE";
    RealTimeEventType[RealTimeEventType["TICKET_PHONE_CALL"] = 311] = "TICKET_PHONE_CALL";
    RealTimeEventType[RealTimeEventType["TICKET_CSAT"] = 312] = "TICKET_CSAT";
    RealTimeEventType[RealTimeEventType["TICKET_AGENT_MESSAGE_STATUS_CHANGED"] = 315] = "TICKET_AGENT_MESSAGE_STATUS_CHANGED";
    RealTimeEventType[RealTimeEventType["TICKET_AGENT_REPLY_READ"] = 316] = "TICKET_AGENT_REPLY_READ";
    RealTimeEventType[RealTimeEventType["TICKET_METADATA_CHANGED"] = 320] = "TICKET_METADATA_CHANGED";
    RealTimeEventType[RealTimeEventType["TICKET_HISTORY_EVENT"] = 325] = "TICKET_HISTORY_EVENT";
    RealTimeEventType[RealTimeEventType["TICKET_FALLBACK_POLL"] = 330] = "TICKET_FALLBACK_POLL";
    RealTimeEventType[RealTimeEventType["TICKET_DELETED"] = 335] = "TICKET_DELETED";
    RealTimeEventType[RealTimeEventType["TICKET_PRESENCE"] = 340] = "TICKET_PRESENCE";
    RealTimeEventType[RealTimeEventType["ACCOUNT_CHAT_USER_MESSAGE"] = 400] = "ACCOUNT_CHAT_USER_MESSAGE";
    RealTimeEventType[RealTimeEventType["ACCOUNT_CHAT_AGENT_MESSAGE"] = 410] = "ACCOUNT_CHAT_AGENT_MESSAGE";
    RealTimeEventType[RealTimeEventType["ACCOUNT_CHAT_STATUS_CHANGED"] = 420] = "ACCOUNT_CHAT_STATUS_CHANGED";
    RealTimeEventType[RealTimeEventType["ACCOUNT_CHAT_STARTED"] = 430] = "ACCOUNT_CHAT_STARTED";
    RealTimeEventType[RealTimeEventType["ACCOUNT_CHAT_USER_CHANGED"] = 440] = "ACCOUNT_CHAT_USER_CHANGED";
    RealTimeEventType[RealTimeEventType["ACCOUNT_CHAT_REOPENED"] = 450] = "ACCOUNT_CHAT_REOPENED";
    RealTimeEventType[RealTimeEventType["AGENT_WEB_NOTIFICATION"] = 500] = "AGENT_WEB_NOTIFICATION";
    RealTimeEventType[RealTimeEventType["AGENT_UPDATED"] = 505] = "AGENT_UPDATED";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_CHAT_DASHBOARD"] = 800] = "SUBSCRIBE_TO_CHAT_DASHBOARD";
    RealTimeEventType[RealTimeEventType["CHAT_DASHBOARD_AGENT_CHANGE"] = 810] = "CHAT_DASHBOARD_AGENT_CHANGE";
    RealTimeEventType[RealTimeEventType["CHAT_DASHBOARD_TICKET_DATA_CHANGE"] = 820] = "CHAT_DASHBOARD_TICKET_DATA_CHANGE";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_EMAIL_DASHBOARD"] = 700] = "SUBSCRIBE_TO_EMAIL_DASHBOARD";
    RealTimeEventType[RealTimeEventType["EMAIL_DASHBOARD_AGENT_CHANGE"] = 710] = "EMAIL_DASHBOARD_AGENT_CHANGE";
    RealTimeEventType[RealTimeEventType["EMAIL_DASHBOARD_TICKET_DATA_CHANGE"] = 720] = "EMAIL_DASHBOARD_TICKET_DATA_CHANGE";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_TICKET_ERROR"] = 900] = "SUBSCRIBE_TO_TICKET_ERROR";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_ACCOUNT_ERROR"] = 905] = "SUBSCRIBE_TO_ACCOUNT_ERROR";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_IMPORT_ERROR"] = 910] = "SUBSCRIBE_TO_IMPORT_ERROR";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_WEB_NOTIFICATIONS_ERROR"] = 915] = "SUBSCRIBE_TO_WEB_NOTIFICATIONS_ERROR";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_AGENT_STATUS_ERROR"] = 920] = "SUBSCRIBE_TO_AGENT_STATUS_ERROR";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_CONTROL_ROOOM"] = 925] = "SUBSCRIBE_TO_CONTROL_ROOOM";
    RealTimeEventType[RealTimeEventType["SEND_AGENT_REPLY_ERROR"] = 950] = "SEND_AGENT_REPLY_ERROR";
    RealTimeEventType[RealTimeEventType["SUBSCRIBE_TO_PRESENCE"] = 1000] = "SUBSCRIBE_TO_PRESENCE";
})(RealTimeEventType || (RealTimeEventType = {}));
export var RealTimeEventName;
(function (RealTimeEventName) {
    //common dashboard events
    RealTimeEventName["INCREMENT_WAITING_CHATS"] = "incWaitingChats";
    RealTimeEventName["DECREMENT_WAITING_CHATS"] = "decWaitingChats";
    RealTimeEventName["INCREMENT_WAITING_TRANSFERRED_CHAT"] = "incWaitingTransferredTickets";
    RealTimeEventName["DECREMENT_WAITING_TRANSFERRED_CHAT"] = "decWaitingTransferredTickets";
    RealTimeEventName["INCREMENT_ACTIVE_CHATS"] = "incActiveChats";
    RealTimeEventName["DECREMENT_ACTIVE_CHATS"] = "decActiveChats";
    RealTimeEventName["INCREMENT_TOTAL_AGENTS"] = "incTotalAgents";
    RealTimeEventName["DECREMENT_TOTAL_AGENTS"] = "decTotalAgents";
    RealTimeEventName["INCREMENT_ACTIVE_AGENTS"] = "incActiveAgents";
    RealTimeEventName["DECREMENT_ACTIVE_AGENTS"] = "decActiveAgents";
    RealTimeEventName["INCREMENT_AVAILABLE_AGENTS"] = "incAvailableAgents";
    RealTimeEventName["DECREMENT_AVAILABLE_AGENTS"] = "decAvailableAgents";
    RealTimeEventName["INCREMENT_BUSY_AGENTS"] = "incBusyAgents";
    RealTimeEventName["DECREMENT_BUSY_AGENTS"] = "decBusyAgents";
    RealTimeEventName["INCREMENT_MAX_CHAT_WORKLOAD"] = "incMaxChatWorkload";
    RealTimeEventName["DECREMENT_MAX_CHAT_WORKLOAD"] = "decMaxChatWorkload";
    RealTimeEventName["INCREMENT_AGENT_TOTAL_ACTIVE_CHATS"] = "incTotalActivity";
    RealTimeEventName["DECREMENT_AGENT_TOTAL_ACTIVE_CHATS"] = "decTotalActivity";
    //chat dashboard events
    RealTimeEventName["INCREMENT_WAITING_TRANSFERRED_TICKETS"] = "incWaitingTransferredTickets";
    RealTimeEventName["DECREMENT_WAITING_TRANSFERRED_TICKETS"] = "decWaitingTransferredTickets";
    //email dashboard events
    RealTimeEventName["INCREMENT_SLA_ABOUT_TO_BREACHED_TICKETS"] = "incSlaAboutToBreachedTickets";
    RealTimeEventName["DECREMENT_SLA_ABOUT_TO_BREACHED_TICKETS"] = "decSlaAboutToBreachedTickets";
    RealTimeEventName["INCREMENT_SLA_BREACHED_TICKETS"] = "incSlaBreachedTickets";
    RealTimeEventName["DECREMENT_SLA_BREACHED_TICKETS"] = "decSlaBreachedTickets";
    //control room events
    RealTimeEventName["CONTROL_ROOM_AGENT_UPDATED"] = "agentUpdated";
})(RealTimeEventName || (RealTimeEventName = {}));
export var RealTimeChannelName;
(function (RealTimeChannelName) {
    RealTimeChannelName["EMAIL_DASHBOARD"] = "TICKETING_DASHBOARD_EVENTS";
    RealTimeChannelName["CHAT_DASHBOARD"] = "CHAT_DASHBOARD_EVENTS";
    RealTimeChannelName["CALL_CENTER_DASHBOARD"] = "CALL_CENTER_DASHBOARD_EVENTS";
    RealTimeChannelName["CONTROL_ROOM_TEAM_MEMBERS"] = "CONTROL_ROOM_EVENTS";
})(RealTimeChannelName || (RealTimeChannelName = {}));
//# sourceMappingURL=domain.js.map